import { blockCategories } from '../../categories';

const COMPONENT_TYPE = 'days-section';
const BLOCK_ID = 'days-section';
const PLACEHOLDER_LABEL = 'Tagesplanung';

export default function daysSection(editor) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    domComponents.addType(COMPONENT_TYPE, {
        isComponent: (el) => {
            if (
                el?.classList?.contains('sio-days-section') ||
                el?.getAttribute?.('data-siotype') === COMPONENT_TYPE
            ) {
                return { type: COMPONENT_TYPE };
            }
            return undefined;
        },

        model: {
            defaults: {
                tagName: 'div',
                name: 'Tagesplanung',
                droppable: false,
                draggable: true,
                stylable: true,
                highlightable: true,
                editable: false,
                attributes: {
                    class: 'sio-jd-days',
                    'data-siotype': COMPONENT_TYPE,
                    'data-field-label': PLACEHOLDER_LABEL,
                },
                components: [],
                traits: [
                    {
                        type: 'checkbox',
                        label: 'Im Akkordeon anzeigen',
                        name: 'showInAccordion',
                        valueTrue: true,
                        valueFalse: false,
                        default: false,
                        changeProp: 1,
                    },
                ],
            },
        },

        view: {},
    });

    blockManager.add(BLOCK_ID, {
        label: 'Tagesplanung',
        category: blockCategories.journeyDetail,
        media: `<svg viewBox="0 0 24 24">
            <path fill="currentColor" d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm0 16H5V9h14v11Zm-9-7H7v-2h3v2Zm4 0h-2v-2h2v2Zm4 0h-2v-2h2v2Zm-8 4H7v-2h3v2Zm4 0h-2v-2h2v2Zm4 0h-2v-2h2v2Z"/>
        </svg>`,

        content: {
            type: COMPONENT_TYPE,
            attributes: {
                class: 'sio-jd-days',
                'data-siotype': COMPONENT_TYPE,
                'data-field-label': PLACEHOLDER_LABEL,
            },
        },
    });
}
